const settings = {
	endpoint: 'https://adxpace.com/api'
}

export { settings };
